module.exports = __webpack_public_path__ + "media/images/homepage-f18dbdcec371a3d939522585169871b0.jpeg";